export enum MessagesEnum {
  FRIEND_INVITED_SUCCESSFULLY = 'Friend invitation sent successfully!'
}
